import { render, staticRenderFns } from "./QuiltyResourceCreateView.vue?vue&type=template&id=16ae9d92&"
import script from "./QuiltyResourceCreateView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports